export enum SupportTicketCategory {
  TECHNICAL = 'technical',
  FINANCIAL = 'financial',
  ACCOUNT = 'account',
  CARD = 'card',
  SWAP = 'swap',
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
  INTERNAL = 'internal',
  OTHER = 'other',
}

export enum SupportTicketStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  WAITING_FOR_USER = 'waiting_for_user',
  WAITING_FOR_ADMIN = 'waiting_for_admin',
  RESOLVED = 'resolved',
  CLOSED = 'closed',
}

export enum SupportTicketPriority {
  NOT_URGENT = 'not_urgent',
  URGENT = 'urgent',
}

export type TNewTicketData = {
  userId: string;
  message: string;
  category: SupportTicketCategory;
  metadata?: Record<string, unknown>;
};

export type TUser = {
  coins_fly_id: string;
};

export type TTicketData = TNewTicketData & {
  id: string;
  status: SupportTicketStatus;
  priority: SupportTicketPriority;
  adminNotes?: string;
  assignedAdminId?: string;
  scheduledContactTime?: Date;
  isEscalated: boolean;
  escalationReason?: string;
  createdAt: Date;
  updatedAt: Date;
  resolvedAt?: Date;
  closedAt?: Date;
  user: TUser;
};

export type TUpdateTicketData = {
  message?: string;
  category?: SupportTicketCategory;
  status?: SupportTicketStatus;
  priority?: SupportTicketPriority;
  adminNotes?: string;
  assignedAdminId?: string;
  metadata?: Record<string, unknown>;
};
